module.exports = __webpack_public_path__ + "assets/img/images-columns-1.7862c6ed.jpg";